import { type CancelPendingAnimationTimeouts } from './types';

/**
 * JQuery data key for `animateElement` completion timeouts.
 *
 * Group Carousel reset cannot import this module at runtime (`@divi/script-library` is a webpack
 * external on frontend module scripts) and uses `window.et_cancel_pending_animation_timeouts`.
 */
export const ANIMATION_TIMEOUTS_DATA_KEY = 'et_animation_timeouts';

/**
 * Cancel `removeAnimation` timers from a previous `animateElement` play.
 *
 * Reset-and-replay callers must clear these. Otherwise a still-pending waypoint timeout stamps
 * `et_had_animation` and strips classes mid-replay.
 *
 * @since ??
 *
 * @param {JQuery} $element Element whose pending animation timeouts should be cleared.
 *
 * @returns {void}
 */
export const cancelPendingAnimationTimeouts: CancelPendingAnimationTimeouts = $element => {
  const timeouts = $element.data(ANIMATION_TIMEOUTS_DATA_KEY);

  if (Array.isArray(timeouts)) {
    timeouts.forEach(timeoutId => {
      if ('number' === typeof timeoutId) {
        window.clearTimeout(timeoutId);
      }
    });
  }

  $element.removeData(ANIMATION_TIMEOUTS_DATA_KEY);
};

/**
 * Remember an `animateElement` completion timeout so reset can cancel it.
 *
 * @since ??
 *
 * @param {JQuery} $element Element the timeout belongs to.
 * @param {number} timeoutId `setTimeout` id from the current play.
 *
 * @returns {void}
 */
export const storeAnimationTimeout = ($element: JQuery<HTMLElement>, timeoutId: number): void => {
  const timeouts = $element.data(ANIMATION_TIMEOUTS_DATA_KEY);
  const nextTimeouts = Array.isArray(timeouts) ? [...timeouts, timeoutId] : [timeoutId];

  $element.data(ANIMATION_TIMEOUTS_DATA_KEY, nextTimeouts);
};
